module.exports = "{{content}}";
